import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Loader from '../Loader'
import { useNavigate } from 'react-router-dom'
import { postApiAdmin } from '../../service'
import { useSelector } from 'react-redux'
import { ADMIN_API } from '../../common/common'
import { Logout } from '../../common/Funcation'
import Cookies from 'universal-cookie'
import moment from 'moment'
import SkyPopup from '../SkyPopup'
import DatePicker from 'react-datepicker'
// @ts-ignore
import 'react-datepicker/dist/react-datepicker.css'
import { getTheme } from '../../common/StyleSeter'

function statementKind(item: any) {
    if (item?.type === 'casino' || item?.casinoMatchId || item?.casinoBonusId) return 'Casino'
    if (item?.type === 'sport' || item?.type === 'commission' || item?.matchId) return 'Sport'
    return ''
}

function AccountStatementNew() {
    const cookies = useMemo(() => new Cookies(), [])
    const [isLoadingMain, setIsLoadingMain] = useState(false)
    const [pageData, setPageData] = useState<any[]>([])
    const [OpenModal, setOpenModal] = useState(false)
    const [betView, setBetView] = useState<any>()
    const navigate = useNavigate()
    const userData = useSelector((e: any) => e.userData);
    const [duringFilter, setDuringFilter] = useState('all');
    const [during, setDuring] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [showFromCalendar, setShowFromCalendar] = useState(false);
    const [showToCalendar, setShowToCalendar] = useState(false);
    const HeaderData = useSelector((e: any) => e.Header);
    const DD = useSelector((e: any) => e.domainDetails);

    const userId = HeaderData?._id

    const getPageData = useCallback(async (from: Date | null = null, to: Date | null = null, FILTER: any = { reportType: '', report: '' }, PAGE: string = '1',) => {
        setIsLoadingMain(true)
        let data: any = {
            api: ADMIN_API.MY_ACCOUNT.GET_STATEMENTS,
            value: {
                id: userId ? userId : userData?._id,
                page: PAGE ? PAGE : '1',
                limit: '10'
            },
        }
        //reportType
        //report

        if (to) { data.value.to = moment(to).format('YYYY-MM-DD') }
        if (from) { data.value.from = moment(from).format('YYYY-MM-DD') }
        if (FILTER.reportType !== '') {
            data.value.type = FILTER.reportType
        }

        await postApiAdmin(data).then(function (response) {
            const responseData = response.data.data;
            // console.log(responseData);
            setPageData(responseData?.userStatement?.results ?? []);
            setIsLoadingMain(false)

        }).catch(err => {

            if (err.response.data.statusCode === 401) {
                setIsLoadingMain(false)
                Logout()
                navigate('/login')
            }
        })
    }, [userId, userData, navigate])

    const handleDateSubmit = (filter = duringFilter) => {
        // Today
        if (filter === 'today') {
            setFromDate(new Date());
            setToDate(new Date());
            getPageData(new Date(), new Date());
        }

        // Yesterday
        else if (filter === 'yesterday') {
            const yesterday = moment().subtract(1, 'day');
            setFromDate(yesterday.toDate());
            setToDate(yesterday.toDate());
            getPageData(yesterday.toDate(), yesterday.toDate());
        }

        // Last 7 Days
        else if (filter === 'last7days') {
            const startDate = moment().subtract(6, 'days').startOf('day');
            const endDate = moment().endOf('day');
            setFromDate(startDate.toDate());
            setToDate(endDate.toDate());
            getPageData(startDate.toDate(), endDate.toDate());
        }

        // Custom date range
        else {
            getPageData(fromDate, toDate);
        }

        setDuring(false);
    };


    useEffect(() => {
        if (userData || cookies.get('skyTokenFront')) {
            // By default fetch today's data
            getPageData(fromDate, toDate)
        }
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData, cookies, getPageData])

    const remarkClick = async (item: any) => {
        if (!item.matchId) return
        let data: any = {
            api: ADMIN_API.REPORT.STATEMENT_BET_VIEW,
            value: {
                id: userId ? userId : userData?._id,
                matchId: item.matchId,
                betType: item.betType
            },
        }
        if ((item.betType === 'session' || item.betType === 'premium') && item.selection !== '') {
            data.value.selection = item.selection
        }
        await postApiAdmin(data).then(function (response) {
            setBetView(response.data.data)
            setOpenModal(true)
        }).catch(err => {
            setBetView({})
            if (err.response?.data?.statusCode === 401) {
                Logout()
                navigate('/login')
            }
        })
    }

    return (
        <>
            <div className='full-wrap bottomfooter leagues'>
                {isLoadingMain && <div className='loader_top'> <Loader /> </div>}

                <style>{`
                    .paddingZero {
                    padding-left: 0px !important;
                    }
                    .sports-tab-panel {
                        position: relative;
                        overflow-x: auto;
                        overflow-y: hidden;
                    }
                    .sports-tab-panel ul {
                        list-style: none;
                        white-space: nowrap;
                        overflow-x: auto;
                        overflow-y: hidden;
                        -webkit-overflow-scrolling: touch;
                    }
                    .sports-tab-panel-item {
                        cursor: pointer;
                        padding: 0 8px;
                        white-space: nowrap;
                        display: inline-block;
                    }
                    .sports-tab-panel-item h3 {
                        margin: 0;
                        padding: 0;
                    }
                    .sports-tab-panel-item.selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .sports-tab-panel-item.not-selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .tab-slider {
                        transition: left 0.3s ease, width 0.3s ease !important;
                        margin: 0;
                        padding: 0;
                    }
                    .custom-calendar {
                        background: white;
                        border: 1px solid #d4e0e5;
                        border-radius: 0px;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    .custom-calendar .react-datepicker__day--highlighted {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        color: white !important;
                        border-radius: 50%;
                    }
                    .custom-calendar .react-datepicker__day--selected {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        color: white !important;
                        border-radius: 50%;
                    }
                    .custom-calendar .react-datepicker__header {
                        background-color: #f8f9fa;
                        border-bottom: 1px solid #d4e0e5;
                        padding: 0px;
                    }
                    .custom-calendar .react-datepicker__current-month {
                        color: #fff;
                        font-weight: 600;
                        height: 32px;
                        background: ${getTheme(DD?.colorSchema)?.backgroundColor};
                        padding-top: 3px !important;
                    }
                    .custom-calendar .react-datepicker__navigation-icon::before {
                        border-color: white;
                    }
                    .custom-calendar .react-datepicker__navigation-icon:hover::before {
                        border-color: white;
                    }
                    .custom-calendar .react-datepicker__navigation {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        border-radius: 4px;
                        width: 32px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0px;
                    }
                    .custom-calendar .react-datepicker__navigation:hover {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        opacity: 0.8;
                    }
                    .custom-calendar .react-datepicker__day-name {
                        color: #666;
                        font-weight: 500;
                    }
                    .custom-calendar .react-datepicker__day {
                        color: #333;
                    }
                    .custom-calendar .react-datepicker__day:hover {
                        background-color: #e9ecef;
                    }
                    .calendar-dropdown {
                        animation: slideDown 0.3s ease;
                    }

                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            max-height: 0;
                            overflow: hidden;
                        }
                        to {
                            opacity: 1;
                            max-height: 500px;
                            overflow: visible;
                        }
                    }
                `}</style>
                <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }}>
                    {/* <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
                        </svg>
                    </button> */}
                    Account Statement
                    <div className='cross-icon' onClick={() => navigate('/')} />
                </div>
                <div className="pl-filter">
                    <div className="select-container bet-history-dropdown">
                        <div className="pl-filter-first p-0" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <div className="pl-filter-first-time" style={{ position: 'relative', display: 'flex', justifyContent: "start", alignItems: 'center', gap: '8px', width: "100%" }}>
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z"></path>
                                    <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z"></path>
                                </svg>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ position: 'relative', width: "100px", textAlign: "start" }}>
                                        <span className="text-white truncate" onClick={() => { setShowFromCalendar(!showFromCalendar); setShowToCalendar(false); }} style={{ cursor: 'pointer' }}>
                                            {new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(fromDate).replace(/\//g, '-')}
                                        </span>
                                        {showFromCalendar && (
                                            <div className="calendar-dropdown" style={{ position: 'absolute', top: '100%', left: "-40px", zIndex: 1000, }}>
                                                <DatePicker
                                                    selected={fromDate}
                                                    onChange={(date) => { setFromDate(date as Date); setDuringFilter("custom"); setShowFromCalendar(false); }}
                                                    inline
                                                    highlightDates={[fromDate]}
                                                    calendarClassName="custom-calendar"
                                                    dateFormat="dd-MM-yyyy"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ position: 'relative', width: "100px", textAlign: "start" }}>
                                        <span className="text-white truncate" onClick={() => { setShowToCalendar(!showToCalendar); setShowFromCalendar(false); }} style={{ cursor: 'pointer' }}>
                                            {new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(toDate).replace(/\//g, '-')}
                                        </span>
                                        {showToCalendar && (
                                            <div className="calendar-dropdown" style={{ position: 'absolute', top: '100%', left: "-40px", zIndex: 1000 }}>
                                                <DatePicker
                                                    selected={toDate}
                                                    onChange={(date) => { setToDate(date as Date); setDuringFilter("custom"); setShowToCalendar(false); }}
                                                    inline
                                                    highlightDates={[toDate]}
                                                    calendarClassName="custom-calendar"
                                                    dateFormat="dd-MM-yyyy"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button type="button" className="btn btn-primary" style={{ padding: "0 0.5rem 0 0.5rem", height: "31.5px" }} onClick={() => setDuring(!during)}>···</button>
                            <button type="button" className="btn btn-primary" onClick={() => handleDateSubmit()}>Submit</button>
                        </div>
                    </div>
                </div>

                <div className="p-3 inner-sidebar-content" style={{ marginBottom: "4rem" }}>
                    {/* <div className="balance-sec mb-2">
                        <h5>Your Balances</h5>
                        <h6 className="fs-4"> <span>PBU</span> {HeaderData.balance} </h6>
                    </div> */}
                    <div className='balance-deposit-sec'>
                        {pageData.length > 0 ? pageData.map((item: any, i: any) => {
                            return (
                                // <table className="rounded overflow-hidden bg-white table table-bordered">
                                //     <thead>
                                //         <tr>
                                //             <th colSpan={4}>
                                //                 {moment(item.createdAt).format('DD-MM-YYYY hh:mm A')}
                                //                 {statementKind(item) ? ` · ${statementKind(item)}` : ''}
                                //             </th>
                                //         </tr>
                                //     </thead>
                                //     <tbody>

                                //         <tr>
                                //             {item.credit > 0 ?
                                //                 <td width="50%">
                                //                     Credit
                                //                     <strong className="d-block text-green">{Number(item.credit) === 0 ? '--' : item.credit}</strong>
                                //                 </td>
                                //                 :
                                //                 <td width="50%">
                                //                     Debits
                                //                     <strong className="d-block text-danger">{Number(item.debit) === 0 ? '--' : item.debit}</strong>
                                //                 </td>
                                //             }
                                //             <td width="50%">
                                //                 Balance
                                //                 <strong className="d-block">{item.balance}</strong>
                                //             </td>
                                //         </tr>

                                //         <tr>
                                //             <td width="50%" colSpan={4} style={{ fontSize: "14px" }}>
                                //                 Remark
                                //                 <strong
                                //                     className="d-block"
                                //                     style={{ cursor: item.matchId ? 'pointer' : 'default' }}
                                //                     onClick={() => remarkClick(item)}
                                //                 >{item.Remark ? item.Remark : '-'}</strong>
                                //             </td>
                                //         </tr>

                                //         {/* <tr>
                                //                     <td width="40%">From/To</td>
                                //                     <td width="60%">{item.from?.user_name}/{item.to?.user_name}</td>
                                //                 </tr> */}
                                //     </tbody>
                                // </table>
                                <div key={i} style={{ background: "#fff", borderRadius: "0.5rem", fontSize: "12.50px", marginBottom: "0.5rem" }}>
                                    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "0.35rem", borderBottom: "1px solid #d4e0e5" }}>
                                        <span style={{ width: "33.33%" }}>Settled Date</span>
                                        <span style={{ width: "66.66%", color: "#6F8898", fontWeight: 700 }}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</span>
                                    </div>
                                    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "0.35rem", borderBottom: "1px solid #d4e0e5" }}>
                                        <span style={{ width: "33.33%" }}>Deposit</span>
                                        <span style={{ width: "66.66%", color: "#6F8898", fontWeight: 700 }}>{Number(item.credit) === 0 ? '--' : item.credit.toFixed(2)}</span>
                                    </div>
                                    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "0.35rem" }}>
                                        <span style={{ width: "33.33%" }}>Withdraw</span>
                                        <span style={{ width: "66.66%", color: "#6F8898", fontWeight: 700 }}>{Number(item.debit) === 0 ? '--' : `-${item.debit.toFixed(2)}`}</span>
                                    </div>
                                    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "0.35rem" }}>
                                        <span style={{ width: "33.33%" }}>Balance</span>
                                        <span style={{ width: "66.66%", color: "#6F8898", fontWeight: 700 }}>{item.balance.toFixed(2)}</span>
                                    </div>
                                    <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "0.35rem" }}>
                                        <span style={{ width: "33.33%" }}>Remark</span>
                                        <span style={{ width: "66.66%", color: "#6F8898", fontWeight: 700 }}>{item.Remark ? item.Remark : '-'}</span>
                                    </div>
                                </div>
                            )
                        }) : <div className="no-event-outer">
                            <div className="no-event">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                                </svg>
                                No Event
                            </div>
                        </div>}

                    </div>

                </div >
            </div>
            <SkyPopup
                title={`Bet Report`}
                OpenModal={OpenModal}
                closeModel={() => setOpenModal(false)}
                closebtn={true}
            >
                <div>
                    <table role="table" className="table b-table table-bordered">
                        <tbody>
                            <tr role="row" className="pink-bg">
                                <th className="text-left">No</th>
                                <th className="text-center">Nation</th>
                                <th className="text-center">Type</th>
                                <th className="text-center">Side</th>
                                <th className="text-left">Rate</th>
                                <th className="text-left">Amount</th>
                                <th className="text-left">Win/Loss</th>
                                <th className="text-center">Place Date</th>
                            </tr>
                            {betView && betView.betInfo?.length > 0 ?
                                <>
                                    {
                                        betView.betInfo?.map((item: any, i: any) => {
                                            return (
                                                <tr className="cyan-bg" key={item._id || i}>
                                                    <td>{i + 1}</td>
                                                    <td align="center"> {item.selection} </td>
                                                    <td align="center">{item.betType}</td>
                                                    <td align="center"> {item.betSide} </td>
                                                    <td> {item.oddsUp} </td>
                                                    <td>{item.stake}</td>
                                                    <td className={item.tType === "lost" ? 'text-color-red' : "text-color-green"}>{item.profit}</td>
                                                    <td align="center">{moment(item.createdAt).format('DD/MM/YYYY hh:mm A')}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    <tr>
                                        <td colSpan={6} align="right"><strong>Total</strong></td>
                                        <td colSpan={2} className={betView?.total > 0 ? "text-color-green" : "text-color-red"}>{betView?.total}</td>
                                    </tr>
                                </> : <h3>No Data</h3>}
                        </tbody>
                    </table>
                </div>
            </SkyPopup>

            {during && <div className="market-depth-modal">
                <div className="market-title">
                    <h4 style={{ fontSize: "14.5749px" }}>During</h4>
                    <button type="button" onClick={() => setDuring(false)} className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary">
                        <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.80702 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
                        </svg>
                    </button>
                </div>
                <div className="d-flex justify-content-center align-items-center w-100" style={{ padding: "0 0.5rem 0.5rem 0.5rem", background: "#000" }}>
                    <div className="p-2 calendar-button" style={{ background: "#fff", borderRadius: "0.5rem", gap: "0.5rem" }}>
                        <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { handleDateSubmit('today'); setDuringFilter('today'); }}>Today</button>
                        <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { handleDateSubmit('yesterday'); setDuringFilter('yesterday'); }}>From Yesterday</button>
                        <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { handleDateSubmit('last7days'); setDuringFilter('last7days'); }}>Last 7 Days</button>
                    </div>
                </div>
            </div>}
        </>


    )
}

export default AccountStatementNew